import { Box, Button, Card, CardContent, CardHeader, Grid2, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import GolfCourseIcon from '@mui/icons-material/GolfCourse';
import { Link } from 'react-router-dom'
import { useAuth } from '../../../AuthContext';
import { useEffect, useState } from 'react';

export default function ManageCourses() {
  const auth = useAuth();
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    console.log('get');
    auth.request('/api/developer/list').then(result => {
      console.log(result);
      if (result.data.courses) {
        setCourses(result.data.courses);
      }
    });
  }, []);

  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Course Developer
      </Typography>

      <Typography>Create and distribute your own courses and games in the OpenGolfSim store.</Typography>
      <Card sx={{ mt: 4 }}>
        <CardHeader title="My Courses" />
        <CardContent>
          {courses.length ? (
            <List>
              {courses.map(course => (
                <ListItemButton key={course._id} component={Link} to={`./edit/${course._id}`}>
                  <ListItemIcon><GolfCourseIcon /></ListItemIcon>
                  <ListItemText primary={course.title} />
                </ListItemButton>
              ))}
            </List>
          ) : (
            <Typography sx={{ textAlign: 'center', py: 3 }} color="textSecondary">You don't have any courses yet</Typography>
          )}
        </CardContent>
        <Button
          variant="outlined"
          color="primary"
          fullWidth={true}
          component={Link}
          to={`/account/developer/create`}
        >
          Create New Course
        </Button>
      </Card>

      {/* <Grid2 container spacing={3}>
        <Grid2 size={4}>
          <Typography variant="h6">My Courses</Typography>
          <Button fullWidth={true}>Create New Course</Button>
        </Grid2>
        <Grid2 size={4}>
          <Typography variant="h6">Downloads</Typography>
          <Button fullWidth={true}>View All</Button>
        </Grid2>
        <Grid2 size={4}>
          <Typography variant="h6">Sales</Typography>
          <Typography sx={{ py: 4 }} align="center" variant="h2">$2,105.24</Typography>
          <Button fullWidth={true}>Create New Course</Button>
        </Grid2>
      </Grid2> */}
    </Box>
  );
}